var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgBold = function SvgBold(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 7 11",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.333 6.286v2.357H3.5c.644 0 1.167-.528 1.167-1.179 0-.65-.523-1.178-1.167-1.178H2.333Zm3.438-1.512A3.543 3.543 0 0 1 7 7.464C7 9.417 5.433 11 3.5 11H0V0h3.111C4.83 0 6.222 1.407 6.222 3.143c0 .597-.165 1.155-.451 1.63ZM2.333 2.357V3.93h.778c.43 0 .778-.352.778-.786a.782.782 0 0 0-.778-.786h-.778Z",
    fillRule: "nonzero"
  })));
};

export default SvgBold;